import { WidgetProps } from '@rjsf/utils';
import { noop } from 'lodash';

import ReactSelect from 'dashboard/components/ReactSelect';
import { filterErrorsForField } from 'dashboard/components/WorkflowControlPanel/StepConfigAction/rjsf/utils';
import Select, { Option } from 'design-system/components/Select';

export function SelectWidget({
  id,
  options,
  value,
  disabled,
  multiple = false,
  required,
  onChange,
  placeholder = 'Select...',
  formContext,
}: WidgetProps) {
  const errorsForField = formContext?.errorsForStep
    ? filterErrorsForField(formContext.errorsForStep, id)
    : [];
  const enumOptions = options.enumOptions || [];
  if (!enumOptions.length) {
    return (
      <Select
        id={id}
        disabled={true}
        placeholder='No options'
        value={undefined}
        onValueChange={noop}
        hasError={required || errorsForField.length > 0}
      />
    );
  } else if (multiple) {
    return (
      <ReactSelect
        id={id}
        disabled={disabled || !enumOptions.length}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        hasError={errorsForField.length > 0}
        options={enumOptions}
        isMulti
      />
    );
  } else {
    return (
      <Select
        id={id}
        disabled={disabled}
        placeholder={placeholder}
        value={value}
        onValueChange={onChange}
        hasError={errorsForField.length > 0}
      >
        {enumOptions.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
    );
  }
}
